import styled, { keyframes } from "styled-components";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const ScrollArea = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const ContainerGrid = styled.div`
  padding: 8px 30px 30px;
`;

export const GridList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 22px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 10px 24px -14px rgba(20, 30, 60, 0.22);
  opacity: 0;
  animation: ${fadeUp} 0.5s ease forwards;
  animation-delay: ${({ index = 0 }) => Math.min(index * 0.06, 0.4)}s;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(47, 111, 237, 0.35);
    box-shadow: 0 20px 36px -16px rgba(47, 111, 237, 0.32);
  }
`;

export const HeaderGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  background: linear-gradient(135deg, #2f6fed 0%, #8f5ff0 100%);
`;

export const HeaderIcon = styled.img`
  height: 40px;
  width: 40px;
  padding: 3px;
  border-radius: 50%;
  background-color: #fff;
  flex-shrink: 0;
  object-fit: contain;
`;

export const HeaderText = styled.div`
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.3;
`;

export const BodyGrid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 18px;
`;

export const BodyContent = styled.div`
  flex: 1;
  min-height: 84px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 13.5px;
  line-height: 1.55;
`;

export const ContainerGridButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const GridButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  color: #fff;
  padding: 9px 18px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #2f6fed 0%, #8f5ff0 100%);
  box-shadow: 0 10px 20px -10px rgba(47, 111, 237, 0.55);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  svg {
    transition: transform 0.25s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 26px -10px rgba(47, 111, 237, 0.6);
  }

  &:hover svg {
    transform: translateX(3px);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -60%;
    width: 40%;
    height: 100%;
    background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.35), transparent);
    transform: skewX(-20deg);
    transition: left 0.6s ease;
  }

  &:hover::before {
    left: 130%;
  }
`;

export const CenteredState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 60px 20px;
  color: ${({ theme }) => theme.colors.textSecondary};
  text-align: center;

  svg {
    opacity: 0.5;
  }
`;
